import { render, staticRenderFns } from "./paysend.vue?vue&type=template&id=2ddb137d&scoped=true&"
import script from "./paysend.vue?vue&type=script&lang=js&"
export * from "./paysend.vue?vue&type=script&lang=js&"
import style0 from "./paysend.vue?vue&type=style&index=0&id=2ddb137d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb137d",
  null
  
)

export default component.exports